import ApiService from '@/services/api.service';

export async function selectWord(id, selection) {
  const response = await ApiService.post('/ocr/' + id + '/select/word', selection);

  try {
    let text = response.data.text;
    return text;
  } catch(err) {

  }
  return null;
}

export async function selectParagraph(id, selection) {
  const response = await ApiService.post('/ocr/' + id + '/select/paragraph', selection);

  try {
    let lines = response.data;
    let text = "";
    for(let i = 0; i < lines.length; i++) {
      text += lines[i].text + "\n";
    }
    return text.trim();
  } catch(err) {

  }
  return null;
}

export async function selectAddress(id, selection) {
  const response = await ApiService.post('/ocr/' + id + '/select/address', selection);
  return response.data;
}

export async function saveAddress(type, selection) {
  const response = await ApiService.post('/ocr_address/' + type, selection);
  return response.data;
}

export async function searchAddress(type, query) {
  const response = await ApiService.query('/ocr_address/' + type + '/search/' + query);
  return response.data;
}

export async function getMAWB(id) {
  let params = {};
  const response = await ApiService.query("/ocr/" + id + "/document/a", {params: params});
  return response.data;
}

export async function getBySerialNumber(serialNumber) {
  let params = {};
  const response = await ApiService.query("/ocr/document/find/serialnumber/" + serialNumber, {params: params});
  return response.data;
}

export async function getHAWBs(id) {
  let params = {};
  const response = await ApiService.query("/ocr/" + id + "/documents", {params: params});
  return response.data;
}

export async function getHAWBBySerialNumber(serialNumber) {
  let params = {};
  const response = await ApiService.query("/ocr/hawb/documents/find/serialnumber/" + serialNumber , {params: params});
  return response.data;
}

export async function getNext(id) {
  let params = {};
  const response = await ApiService.query("/ocr/next/" + id, {params: params});
  return response.data;
}

export async function getPrev(id) {
  let params = {};
  const response = await ApiService.query("/ocr/prev/" + id, {params: params});
  return response.data;
}

export async function getDocumentUrl(id) {
  let params = {};
  const response = await ApiService.query("/ocr/" + id + '/image');
  return response.data;
}

export async function getDocumentStatus(id) {
  const response = await ApiService.query("/ocr/status/" + id);
  return response.data;
}

export async function releaseDocument(id) {
  const response = await ApiService.query("/ocr/release/" + id);
  return response.data;
}




export async function getDocument(id) {
  let params = {};
  const response = await ApiService.query("/ocr/" + id + '/dss/document');
  return response.data;
}

export async function indexDocument(id) {
  let params = {};
  const response = await ApiService.query("/ocr/" + id + '/dss/index');
  return response.data;
}

export async function indexDocuments() {
  let params = {};
  const response = await ApiService.query("/ocr/dss/indexall");
  return response.data;
}

export async function updateDSSDocument(id, type, data) {
  const response = await ApiService.post('/ocr/' + id + '/dss/update/' + type, data);
  return response.data;
}

export async function getPages(parentId) {
  const response = await ApiService.query('/ocr/pages/' + parentId);
  return response.data;
}

export async function getDevices() {
  const response = await ApiService.query('/ocr/devices');
  return response.data;
}